import React from 'react';
import { 
  Typography, 
  Box, 
  Paper
} from '@mui/material';
import PromptUploadTab from './PromptUploadTab';

/**
 * TestEngineeringView component for displaying test engineering metrics and activities
 * @returns {JSX.Element} TestEngineeringView component
 */
const TestEngineeringView = () => {
  return (
    <Box sx={{ width: '100%', maxWidth: '100%' }}>
      <Box mb={3}>
        <Typography variant="h4" gutterBottom>
          Test Engineering
        </Typography>
        <Typography variant="body1" color="textSecondary">
          Manage test engineering activities and metrics
        </Typography>
      </Box>
      
      <Paper elevation={2} sx={{ width: '100%', maxWidth: '100%' }}>
        <Box sx={{ p: 3 }}>
          <PromptUploadTab />
        </Box>
      </Paper>
    </Box>
  );
};

export default TestEngineeringView;
